// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"UseStartingUrl_copyButton_ldgFP","copyButton__tooltip":"UseStartingUrl_copyButton__tooltip_2C9vL"};